import dayjs from "dayjs";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

export const LastOrderYearDate = dayjs()
  .set('year', publicRuntimeConfig.lastOrderYear)
  .endOf('year')
  .toDate();
